import { FaneventTitle } from "../common/faneventTitle";
import { useAtomValue } from "jotai";
import { currentArtistAtom } from "../../atoms/artistAtom";
import { useNavigate } from "react-router-dom";
import { ArtistSelector } from "../common/artistSelector";
import { isBackstageUserAtom } from "../../atoms/userAtom";
import { BackstageHeader } from "../common/backstageHeader";

export function CheckInsHeader() {
  const currentArtist = useAtomValue(currentArtistAtom);
  const navigate = useNavigate();
  const isBackstageUser = useAtomValue(isBackstageUserAtom);
  return isBackstageUser ? (
    <BackstageHeader title={currentArtist?.name} />
  ) : (
    <div className="navbar bg-base-100 drop-shadow flex-shrink-0">
      <div className="flex-1">
        <div className="gap-2 justify-items-center items-center text-primary wev-icon hidden xs:flex">
          <FaneventTitle badgeOnly />
        </div>
      </div>
      <ArtistSelector
        selected={currentArtist}
        onChange={(selected) => {
          navigate(`/events/checkins?artist=${selected.id}`);
        }}
      />
      <div className="flex-none">
        <label
          htmlFor={"main-drawer"}
          className="btn btn-square btn-ghost drawer-button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="inline-block w-5 h-5 stroke-current"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </label>
      </div>
    </div>
  );
}
